import React from "react";
import ScorePlus from "./modules/scoreplus/ScorePlus";

const ScorePlusHome = ({
    useSample = false,
    isActiveSub = true,
    subscriptionId,
    startDate,
    endDate,
}) => {

    return (
        <ScorePlus
            useSample={useSample}
            isActiveSub={isActiveSub}
            subscriptionId={subscriptionId}
            startDate={startDate}
            endDate={endDate}
        />
    );
};

export default ScorePlusHome;